import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tipoCombustivel", "litros", "precoLitro", "valor"]

  connect() {
    this._updateLabels()
    this._calculate()
  }

  calculate() {
    this._calculate()
  }

  updateLabels() {
    this._updateLabels()
  }

  _calculate() {
    const valor = this._parseMoney(this.valorTarget.value)
    const litros = this._parseLitros(this.litrosTarget.value)

    if (valor > 0 && litros > 0) {
      this.precoLitroTarget.value = (valor / litros).toFixed(2).replace(".", ",")
    } else {
      this.precoLitroTarget.value = ""
    }
  }

  _updateLabels() {
    if (!this.hasTipoCombustivelTarget) return

    const eletrico = this.tipoCombustivelTarget.value === "ELETRICO"
    const litrosLabel = eletrico ? "kWh" : "Litros"
    const precoLabel = eletrico ? "Preço kWh" : "Preço litro"

    this.litrosTarget.placeholder = litrosLabel
    this.precoLitroTarget.placeholder = precoLabel

    const litrosTooltip = this.litrosTarget.closest(".tooltip")
    if (litrosTooltip) litrosTooltip.dataset.tooltip = eletrico ? "Quantidade de kWh" : "Litragem abastecida"

    const precoTooltip = this.precoLitroTarget.closest(".tooltip")
    if (precoTooltip) precoTooltip.dataset.tooltip = eletrico ? "Preço do kWh" : "Preço do litro"
  }

  _parseMoney(val) {
    if (!val) return 0
    return parseFloat(val.replace(/\./g, "").replace(",", ".")) || 0
  }

  _parseLitros(val) {
    if (!val) return 0
    return parseFloat(val.replace(",", ".")) || 0
  }
}
